import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MonitorInteraction } from './api/monitorsModels';

export type MonitorState = {
    monitorActionTaken: MonitorInteraction;
};

const initialState: MonitorState = {
    monitorActionTaken: "NONE",
};

const monitorSlice = createSlice({
    name: 'monitor',
    initialState,
    reducers: {
        handleMonitorAction(state, action: PayloadAction<MonitorInteraction>) {
            state.monitorActionTaken = action.payload;
        },
    },
});

export const {handleMonitorAction} = monitorSlice.actions;
//Exporting these as actionCreators to fit with the existing pattern in the application
export const actionCreators = {
    handleMonitorAction
}
export default monitorSlice.reducer;
